import { f as o } from "./index743.mjs";
import { i as t } from "./index761.mjs";
import { s as n } from "./index851.mjs";
var s = o, e = t, r = n, a = s(Function.toString);
e(r.inspectSource) || (r.inspectSource = function(i) {
  return a(i);
});
var f = r.inspectSource;
export {
  f as i
};
